import apiClient from "../apiClient";
import { ENDPOINTS } from "../endpoints";

export const searchService = {
  global: async (q, limit = 10) =>
    (await apiClient.get(ENDPOINTS.search, { params: { q, limit } })).data,
};
